import React, { useEffect, useRef, useState } from 'react';
import { FaCalendarAlt, FaEdit } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import { Modal } from 'react-bootstrap';
import CustomTable from '../../../../customComponents/CustomTable';
import AcceptedSerialList from './SerialList';
import Swal from 'sweetalert2';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import downloadIcon from '../../../../../Assets/icons/download.svg';
import './AcceptOrderDetails.scss';
import backicon from '../../../../../Assets/icons/backIcon.svg';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
// import cancelCsv from "../../../../../Assets/icons/cancelCsv.svg"
import cancelCsv from '../../../../../Assets/icons/cancelCsv.svg';
import editIcon from '../../../../../Assets/icons/Un-Checkbox.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { GiCancel } from 'react-icons/gi';
import { showErrorAlert } from '../../../../customComponents/CustomSweetAlert/errorsweetalert';
import validations from '../../../../../helpers/validations';

const AcceptOrderDetails = () => {
  const [poDetails, setPoDetails] = useState({});
  const [vehicleData, setVehicleData] = useState([]);
  const [accessoryData, setAccessoryData] = useState([]);
  const [sparePartData, setSparePartData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tablepaymentStatus, setTablePaymentStatus] = useState([]);

  const [withoutExcelSerialNumbers, setWithoutExcelSerialNumbers] = useState(
    [],
  );
  const [serialInputRows, setSerialInputRows] = useState([]);

  const [poStatusVal, setPoStatusVal] = useState('');
  const [batteryCloseModal, setBatteryCloseModal] = useState(0);

  const [error, setError] = useState('');

  // Date modal per item
  const [showDateModal, setShowDateModal] = useState(false);
  const [bulkExpectedDeliveryDate, setBulkExpectedDeliveryDate] =
    useState(false);

  const [showAvailableStockMessage, setShowAvailableStockMessage] =
    useState('');
  const [availableQuantity, setAvailableQuantity] = useState(null);

  const [rejectModalPopup, setRejectModalPopup] = useState(false);

  const [batteryModal, setBatteryModal] = useState(false);
  const [batteryDetails, setBatteryDetails] = useState({});

  const [expectedDate, setExpectedDate] = useState('');

  const [validCountData, setValidCountData] = useState(0);
  const [inValidCountData, setInValidCountData] = useState(0);

  const [rejectModal, setRejectModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const [variantOptions, setVariantOptions] = useState([]);
  const [orderformData, setOrderFormData] = useState([]);
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [damagedQty, setDamagedQty] = useState(0); // New state to manage damaged quantity
  const [selectedItemType, setSelectedItemType] = useState('');
  const location = useLocation();
  const data = location?.state?.data;
  console.log('locationdata', data);
  const [podetaildID, setPoDetailsID] = useState();
  const authToken = localStorage.getItem('authToken');
  // const podetailsid = location?.state?.data?.po_details_id
  const [viewItemType, setViewItemType] = useState('');
  const [showSerialModal, setShowSerialModal] = useState(false);
  const [serialData, setSerialData] = useState([]);
  const [loadingSerialData, setLoadingSerialData] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [podetailsid, setpodetailsid] = useState();
  const [orderAcceptedVal, setIsOrderAcceptedVal] = useState();
  const [batteryNumbers, setBatteryNumbers] = useState([]);
  const [batteryErrors, setBatteryErrors] = useState([]);

  const [totalRecords, setTotalRecords] = useState(0);

  const [errorVal, setErrorVal] = useState(0);
  const [successVal, setSuccessVal] = useState(0);

  const [selectedItem, setSelectedItem] = useState(null);

  const [remark, setRemark] = useState('');

  const [rejectRemark, setRejectRemark] = useState('');

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [acceptModal, setAcceptModal] = useState(false);

  const [batteryTableDetails, setBatteryTableDetails] = useState([]);

  console.log('postatus', poDetails);

  useEffect(() => {
    const qty = Number(batteryDetails?.total_battery_qty) || 0;
    setBatteryNumbers((prev) =>
      prev.length === qty
        ? prev
        : Array(qty)
            .fill('')
            .map((v, i) => prev[i] ?? ''),
    );
    setBatteryErrors((prev) =>
      prev.length === qty ? prev : Array(qty).fill(null),
    );
  }, [batteryDetails?.total_battery_qty]);

  const handleAcceptModalOpen = () => {
    console.log('clicked');
    setAcceptModal(true);
  };

  const closeAcceptModal = () => {
    setAcceptModal(false);
  };

  // WITHOUT SERIAL NOS
  // const fetchPoDetailWithoutExcel = async () => {
  //   try {
  //     const results = withoutExcelSerialNumbers.map((item, index) => ({
  //       PoNo: item?.PoNo || "",
  //       PoDetailNO: item?.PoDetailNO || "",
  //       Model: item?.Model || "",
  //       Variant: item?.Variant || "",
  //       Color: item?.Color || "",
  //       Item: item?.Item || "",
  //       VinNo: serialInputRows[index]?.vin_no || "",
  //       ControllerNo: serialInputRows[index]?.controller_no || "",
  //       MotorNo: serialInputRows[index]?.motor_no || "", // or charger_no if backend expects that
  //       SerialNo: "",
  //     }));

  //     const payload = {
  //       results,
  //     };

  //     const response = await axiosInstance.post(
  //       `/podetails/acceptpodetailWithoutExcel`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       },
  //     );

  //     if (response.status === 200) {
  //       Swal.fire({
  //         title: "Success",
  //         text: "Serial Numbers added successfully!",
  //         icon: "success",
  //         confirmButtonText: "OK",
  //       }).then(() => {
  //         //   navigate("/manage-services/check-warranty");
  //       });
  //       fetchOrderDetails();
  //       handleModalClose();
  //     }

  //     console.log("Success response:", response?.data);
  //   } catch (error) {
  //     console.error("Error accepting PO details:", error);
  //   }
  // };

  // const handleSubmitWithoutExcel = () => {
  //   const isVehicle = selectedItemType === 'Vehicle';
  //   const isSpareOrAccessory = !isVehicle;

  //   const hasInvalidRow = serialInputRows.some((row) => {
  //     if (isVehicle) {
  //       return (
  //         !row?.vin_no?.trim() ||
  //         !row?.controller_no?.trim() ||
  //         !row?.motor_no?.trim()
  //       );
  //     }

  //     if (isSpareOrAccessory) {
  //       return !row?.serial_no?.trim();
  //     }

  //     return false;
  //   });

  //   if (hasInvalidRow) {
  //     Swal.fire({
  //       icon: 'warning',
  //       title: 'Incomplete Details',
  //       text: isVehicle
  //         ? 'Please enter VIN No., Controller No. and Motor No. for all vehicles.'
  //         : 'Please enter Serial No. for all items.',
  //       confirmButtonText: 'OK',
  //     });
  //     return; // ⛔ Stop API call
  //   }

  //   // ✅ All validations passed
  //   fetchPoDetailWithoutExcel();
  // };
const handleSubmitWithoutExcel = async () => {
  try {
    const isVehicle = selectedItemType === 'Vehicle';

    // ✅ Validation function
    const isRowValid = (row) => {
      if (isVehicle) {
        return (
          row?.vin_no?.trim?.() &&
          row?.controller_no?.trim?.() &&
          row?.motor_no?.trim?.()
        );
      } else {
        return row?.serial_no?.trim?.();
      }
    };

    // ✅ Build ONLY valid rows
    const results = withoutExcelSerialNumbers
      .map((item, index) => {
        const inputRow = serialInputRows[index];

        // ❌ Ignore empty / partial rows
        if (!isRowValid(inputRow)) return null;

        const isSpareOrAccessory = !isVehicle;

        return {
          PoNo: item?.PoNo || '',
          PoDetailNO: item?.PoDetailNO || '',

          // VEHICLE DATA
          Model: isVehicle ? item?.Model || '' : '',
          Variant: isVehicle ? item?.Variant || '' : '',
          Color: isVehicle ? item?.Color || '' : '',

          // SPARE / ACCESSORY
          Item: isSpareOrAccessory ? item?.Item || '' : '',

          // USER INPUT
          VinNo: isVehicle ? inputRow?.vin_no || '' : '',
          ControllerNo: isVehicle ? inputRow?.controller_no || '' : '',
          MotorNo: isVehicle ? inputRow?.motor_no || '' : '',
          SerialNo: isSpareOrAccessory
            ? inputRow?.serial_no || ''
            : '',
        };
      })
      .filter(Boolean); // ✅ remove null rows

    // ❌ No valid rows
    if (results.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Data Entered',
        text: isVehicle
          ? 'Please enter at least one complete vehicle row.'
          : 'Please enter at least one Serial No.',
        confirmButtonText: 'OK',
      });
      return;
    }

    const payload = { results };

    console.log('Payload sent:', payload);

    // ✅ API Call
    const response = await axiosInstance.post(
      `/podetails/acceptpodetailWithoutExcel`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    // ✅ Success
    if (response.status === 200) {
      Swal.fire({
        title: 'Success',
        text: 'Serial Numbers added successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      fetchOrderDetails();
      handleModalClose();
    }
  } catch (error) {
    console.error('Error accepting PO details:', error);

    const apiData = error?.response?.data;
    const errors = apiData?.data?.errors || [];

    // ❌ Structured backend errors
    if (errors.length > 0) {
      const errorHtml = errors
        .map(
          (err) => `
          <div style="
            padding: 10px;
            margin-bottom: 8px;
            border-left: 4px solid #e74c3c;
            background: #fff5f5;
            border-radius: 4px;
          ">
            <div><strong>Line:</strong> ${err.lineNumber}</div>
            <div><strong>PO No:</strong> ${err.PoNo}</div>
            <div><strong>PO Detail No:</strong> ${err.PoDetailNO}</div>
            <div style="color:#c0392b;margin-top:4px;">
              ${err.errors.join(', ')}
            </div>
          </div>
        `
        )
        .join('');

      Swal.fire({
        title: 'Error Submitting the serial nos.',
        icon: 'error',
        width: '700px',
        html: `
          <div style="max-height: 400px; overflow-y: auto; text-align: left;">
            ${errorHtml}
          </div>
        `,
        confirmButtonText: 'Retry',
      });

      return;
    }

    // ❌ Generic error
    Swal.fire({
      title: 'Something went wrong',
      text:
        apiData?.message ||
        'Unable to submit PO details. Please try again.',
      icon: 'error',
    });
  }
};

  const fetchPoDetailWithoutExcel = async () => {
    try {
      const results = withoutExcelSerialNumbers.map((item, index) => {
        const isVehicle = selectedItemType === 'Vehicle';
        const isSpareOrAccessory = !isVehicle;

        return {
          PoNo: item?.PoNo || '',
          PoDetailNO: item?.PoDetailNO || '',

          // VEHICLE FIELDS
          Model: isVehicle ? item?.Model || '' : '',
          Variant: isVehicle ? item?.Variant || '' : '',
          Color: isVehicle ? item?.Color || '' : '',

          // SPARE / ACCESSORY FIELD
          Item: isSpareOrAccessory ? item?.Item || '' : '',

          // INPUT VALUES
          VinNo: isVehicle ? serialInputRows[index]?.vin_no || '' : '',
          ControllerNo: isVehicle
            ? serialInputRows[index]?.controller_no || ''
            : '',
          MotorNo: isVehicle ? serialInputRows[index]?.motor_no || '' : '',

          SerialNo: isSpareOrAccessory
            ? serialInputRows[index]?.serial_no || ''
            : '',
        };
      });

      const payload = { results };

      const response = await axiosInstance.post(
        `/podetails/acceptpodetailWithoutExcel`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.status === 200) {
        Swal.fire({
          title: 'Success',
          text: 'Serial Numbers added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });

        fetchOrderDetails();
        handleModalClose();
      }

      console.log('Payload sent:', payload);
    } catch (error) {
      console.error('Error accepting PO details:', error);

      const apiData = error?.response?.data;
      const errors = apiData?.data?.errors || [];

      if (errors.length > 0) {
        const errorHtml = errors
          .map(
            (err) => `
          <div style="
            padding: 10px;
            margin-bottom: 8px;
            border-left: 4px solid #e74c3c;
            background: #fff5f5;
            border-radius: 4px;
          ">
            <div><strong>Line:</strong> ${err.lineNumber}</div>
            <div><strong>PO No:</strong> ${err.PoNo}</div>
            <div><strong>PO Detail No:</strong> ${err.PoDetailNO}</div>
            <div style="color:#c0392b;margin-top:4px;">
              ${err.errors.join(', ')}
            </div>
          </div>
        `,
          )
          .join('');

        Swal.fire({
          title: 'Error Submitting the serial nos.',
          icon: 'error',
          width: '700px',
          html: `
        <div style="max-height: 400px; overflow-y: auto; text-align: left;">
          ${errorHtml}
        </div>
      `,
          confirmButtonText: 'Retry',
        });

        return;
      }

      // ❌ GENERIC / SERVER ERROR
      Swal.fire({
        title: 'Something went wrong',
        text:
          apiData?.message || 'Unable to submit PO details. Please try again.',
        icon: 'error',
      });
    }
  };

  const fetchPoNumberUpdate = async (item) => {
    try {
      const response = await axiosInstance.get(
        `/sample-poVehicleDetails/${item.po_details_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response?.data?.data || [];
      setWithoutExcelSerialNumbers(fetchedData);

      // initialize inputs for each row
      setSerialInputRows(
        fetchedData.map(() => ({
          vin_no: '',
          controller_no: '',
          motor_no: '',
          serial_no: '',
        })),
      );
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
  };

  const handleInputChange = (index, field, value) => {
    setSerialInputRows((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  useEffect(() => {
    fetchPaymentValues();
  }, []);

  const fetchPaymentValues = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/po-paymnent-history/${data.po_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response?.data?.data?.data;
      console.log(fetchedData, 'fetchedData');
      setTablePaymentStatus(fetchedData);
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
  };

  // const handleChange = (fieldName, date) => {
  //     // Format the date to "dd/MM/yyyy" and update state
  //     const formattedDate = date
  //       ? date.toLocaleDateString("en-GB").replace(/\//g, "/")
  //       : "";
  //     setExpectedDate(formattedDate);
  //   };

  // const handleChange = (fieldName, date) => {
  //   if (date) {
  //     // Format the date to "yyyy-mm-dd"
  //     const formattedDateForPayload = date.toISOString().split("T")[0]; // yyyy-mm-dd

  //     // Optionally format for display if needed in "dd/MM/yyyy"
  //     const formattedDateForDisplay = date
  //       .toLocaleDateString("en-GB")
  //       .replace(/\//g, "/");

  //     // Update state
  //     setExpectedDate(formattedDateForPayload);

  //     // Log or include the payload formatted date where needed
  //     console.log("Date for payload:", formattedDateForPayload);
  //   } else {
  //     setExpectedDate("");
  //   }
  // };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    // fetchActionTaken(newPage);
  };

  const Job_Card_TABLE_HEADERS = [
    // "Date",
    'PO Number',
    'Total Amount',
    'Paid Amount',
    'Pending Amount',
    'Payment Status',
    'Payment Image',
    'Payment Date Time',
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    'PO Number': 'po_number',
    'Total Amount': 'total_amount',
    'Paid Amount': 'paid_amount',
    'Pending Amount': 'pending_amount',
    'Payment Status': 'payment_status',
    'Payment Image': 'payment_image',
    'Payment Date Time': 'payment_date',
  };

  const handleChange = (fieldName, date) => {
    // Format the date to "dd/MM/yyyy" and update state
    const formattedDate = date
      ? date.toLocaleDateString('en-GB').replace(/\//g, '/')
      : '';
    setExpectedDate(formattedDate);
  };

  useEffect(() => {
    setIsButtonDisabled(!formData.uploadDocument);
  }, [formData]);

  const navigate = useNavigate();

  const datePickerRefs = useRef({});

  const openDatePicker = (fieldName) => {
    // Open DatePicker when icon is clicked
    if (datePickerRefs.current[fieldName]) {
      datePickerRefs.current[fieldName].setFocus();
    }
  };

  const [showRejectModal, setShowRejectModal] = useState(false);

  // States for downloading failed records
  const [failedRows, setFailedRows] = useState([]);
  const [uploadedHeaders, setUploadedHeaders] = useState([]);

  useEffect(() => {
    if (data?.po_id) {
      fetchOrderDetails();
    }
  }, [data]);

  const handleCheckStocks = async (item) => {
    // console.log("clicked");
    const payload = {
      variantId: item.variant_id,
      ApprovalPodetailQuantity: item.accepted_qty,
      itemId: item.item_id,
    };

    try {
      const response = await axiosInstance.post(
        `/instock/stock-availability-check`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const { available_quantity, message } = response.data.data;
      setAvailableQuantity(available_quantity);
      setShowAvailableStockMessage(message);

      console.log(response, 'response');
      if (response.status === 200) {
        setExpectedDate(''); // Clear the input field
      }
      // closeDateModal();
      //   fetchPoStockout();
      // fetchActionTaken()
      //   navigate(ROUTES_NAVIGATION.STOCKOUTDETAILS);
      // fetchOrderDetails();
    } catch (error) {
      console.error('Error submitting order:', error);
    }
  };

  const handleBulkDateSubmit = async () => {
    // console.log("clicked");
    const formattedDate = expectedDate.replace(/\//g, '-');
    const payload = {
      podelivery_date: formattedDate,
      po_id: data?.po_id,
    };

    try {
      const response = await axiosInstance.post(
        `/podetails/updateDelevryDate`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log(response, 'response');
      if (response.status === 200) {
        setExpectedDate(''); // Clear the input field
      }
      closeBulkDateModal();
      //   fetchPoStockout();
      // fetchActionTaken()
      //   navigate(ROUTES_NAVIGATION.STOCKOUTDETAILS);
      fetchOrderDetails();
    } catch (error) {
      console.error('Error submitting order:', error);
    }
  };

  const handleDateSubmit = async () => {
    // console.log("clicked");
    const formattedDate = expectedDate.replace(/\//g, '-');
    const payload = {
      podelivery_date: formattedDate,
      po_details_id: podetailsid,
    };

    try {
      const response = await axiosInstance.post(
        `/podetails/updateDelevryDate`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      console.log(response, 'response');
      if (response.status === 200) {
        setExpectedDate(''); // Clear the input field
      }
      closeDateModal();
      //   fetchPoStockout();
      // fetchActionTaken()
      //   navigate(ROUTES_NAVIGATION.STOCKOUTDETAILS);
      fetchOrderDetails();
    } catch (error) {
      console.error('Error submitting order:', error);
    }
  };

  useEffect(() => {
    fetchVariantOptions();
  }, []);

  const fetchVariantOptions = async () => {
    try {
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  // const handleInputChange = (index, field, value) => {
  //   setOrderFormData((prevFormData) => {
  //     const updatedFormData = [...prevFormData];
  //     updatedFormData[index] = { ...updatedFormData[index], [field]: value };
  //     return updatedFormData;
  //   });
  // };

  const handleRejectAPI = async (remark) => {
    try {
      console.log('clicked');

      //   const payload = {
      //    remark
      //   };

      //   const response = await axiosInstance.patch(`/purchaseorder/rejectpurchaseorder/${data?.po_id}`, payload, {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${authToken}`,
      //     },
      //   });

      //   if (response?.status==200) {

      //     navigate(ROUTES_NAVIGATION.MANAGEORDERLIST);
      //   }
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  // const handleApprovalAPIApprove = async (remark) => {
  //   try {
  //     const payload = {
  //       approvestatus: "Accept",
  //       remark: null,
  //     };

  //     const response = await axiosInstance.patch(
  //       `/purchaseorder/rejectpurchaseorder/${data?.po_id}`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     if (response?.status == 200) {
  //       fetchOrderDetails();

  //       // navigate("/admin/manage-order/order");
  //     }
  //   } catch (error) {
  //     console.error("API Error:", error);
  //   }
  // };

  const handleApprovalAPIApprove = async (remark) => {
    // Merge all product types into a single array
    const allItems = [...vehicleData, ...accessoryData, ...sparePartData];

    // Check for items missing both expected date and reject remark
    const incompleteItems = allItems.filter(
      (item) => !item.po_expected_date && !item.rejected_remark,
    );

    // if (incompleteItems.length > 0) {
    //   alert("Please provide either 'Expected Date' or 'Reject Remark' for all items before approving.");
    //   return;
    // }

    if (incompleteItems.length > 0) {
      Swal.fire({
        title: 'Action Required',
        text: 'Either select an Expected Delivery Date or reject the order before approval.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }
    try {
      const payload = {
        approvestatus: 'Accept',
        remark: remark || null,
        expected_delivery_date: expectedDate,
      };

      const response = await axiosInstance.patch(
        `/purchaseorder/rejectpurchaseorder/${data?.po_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response?.status === 200) {
        fetchOrderDetails();
        fetchBatteryDetails();

        Swal.fire({
          title: 'Success',
          text: 'Order approved successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error('API Error:', error);
      Swal.fire({
        title: 'Error',
        text: 'Failed to approve order. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const handleApprovalAPI = async (remark) => {
    try {
      const payload = {
        approvestatus: 'Reject',
        remark,
      };

      const response = await axiosInstance.patch(
        `/purchaseorder/rejectpurchaseorder/${data?.po_id}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response?.status == 200) {
        // navigate("/admin/manage-order/order");
        fetchOrderDetails();
        handleRejectModalClose();
      }
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  const handleRejectAPIItem = async (remark) => {
    try {
      const payload = {
        approvestatus: 'Reject',
        remark,
        po_id: selectedItem?.po_id,
        po_details_id: selectedItem?.po_details_id,
        is_order_accepted: poDetails?.is_order_accepted,
      };

      const response = await axiosInstance.patch(
        `/purchaseorder/rejectorderitem/${podetailsid}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response?.status == 200) {
        // navigate("/admin/manage-order/order");
        fetchOrderDetails();
        handleRejectModalPopupClose();
        setRemark('');
      }
    } catch (error) {
      console.error('API Error:', error);
    }
  };

  const fetchSerialDetails = async (poDetailsId, type) => {
    // setShowSerialModal(true);
    setLoadingSerialData(true);
    console.log(poDetailsId, 'poDetailsId');
    try {
      // const response = await axiosInstance.get(`/podetails/getseriallistpoidwise/${poDetailsId}`, {
      //     headers: {
      //         'Content-Type': 'application/json',
      //         Authorization: `Bearer ${authToken}`,
      //     },
      // });
      const response = await axiosInstance.post(
        `podetails/getseriallistpoidwise`,
        {
          orderBy: 'postockinsr_id desc',
          page: 0,
          pageSize: 10,
          endDate: null,
          startDate: null,
          po_details_id: poDetailsId,
          searchText: null,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      // Assuming the response contains a list of serial numbers, VIN, or chassis numbers
      if (type === 'Vehicle') {
        setSerialData(
          response.data.data.data.map((item) => ({
            chassis_no: item.chassis_no,
            vin_no: item.vin_no,
          })),
        );
      } else {
        setSerialData(
          response.data.data.data.map((item) => ({
            serial_no: item.serial_no,
          })),
        );
      }
      setShowSerialModal(true);
    } catch (error) {
      console.error('Error fetching serial details:', error);
      alert('Failed to fetch serial details');
    } finally {
      setLoadingSerialData(false);
    }
  };

  const onClickNo = async () => {
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to No?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const payload = {
            oem_payment_status: 0,
          };

          const response = await axiosInstance.patch(
            `/podetails/paymentStatusbyOem/${data.po_id}`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
              },
            },
          );
        } catch (error) {
          console.error('API Error:', error);
          const errorMessage = error.response?.data?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Something went wrong',
            text:
              errorMessage ||
              'An error occurred while processing your request.',
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });
    if (!result.isConfirmed) {
      // setLoading(false);
    }
  };

  const onClickYes = async () => {
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to Yes?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const payload = {
            oem_payment_status: 1,
          };

          const response = await axiosInstance.patch(
            `/podetails/paymentStatusbyOem/${data.po_id}`,
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          if (response?.status == 200) {
            // navigate("/admin/manage-order/order");
            fetchOrderDetails();
          }
        } catch (error) {
          console.error('API Error:', error);
          const errorMessage = error.response?.data?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Something went wrong',
            text:
              errorMessage ||
              'An error occurred while processing your request.',
            callback: () => {
              // Optional: code to execute after confirming the alert
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });
    if (!result.isConfirmed) {
      // setLoading(false);
    }
  };

  const TABLE_HEADERS_BATTERY = [
    // "Sr No.",
    // "Color ID",
    'Battery Name',
    'Voltage',
    'Total Battery Quantity',
    'Action',
  ];

  const keyMappingBattery = {
    // "Sr No.": "Sr No.",
    // "Color ID": "color_id",
    'Battery Name': 'battryName',
    Voltage: 'voltage',
    'Total Battery Quantity': 'total_battery_qty',
    Action: [{ type: 'edit', icon: editIcon, label: 'Edit' }],
  };

  const handleEdit = (rowData) => {
    console.log('rowdata>', rowData);
    setBatteryModal(true);
    setBatteryDetails(rowData);
  };

  // useEffect(() => {
  //   fetchBatteryDetails();
  // }, []);

  const fetchBatteryDetails = async () => {
    try {
      const response = await axiosInstance.post(
        `/purchaseorder/batteryorderonvariant`,
        {
          // ${data.po_id}
          poId: data?.po_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedBatteryDetails = response?.data?.data;
      setBatteryTableDetails(fetchedBatteryDetails);
      console.log(fetchedBatteryDetails, 'fetchedBatteryDetails');
      fetchOrderDetails();
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
  };

  const fetchOrderDetails = async () => {
    try {
      const response = await axiosInstance.get(
        `/purchaseorder/edit/${data.po_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const fetchedData = response.data.data;
      const podetailsValueData = fetchedData?.Purchaseorderdetails[0];
      console.log(podetailsValueData?.postatus, 'podetailsValueData');
      setPoDetails(fetchedData.Purchaseorderdetails[0]);
      // is_order_accepted
      const isOrderAccepted =
        fetchedData.Purchaseorderdetails[0].is_order_accepted;
      const poStatus = fetchedData.Purchaseorderdetails[0].postatus;
      setPoStatusVal(poStatus);

      console.log(isOrderAccepted, 'isOrderAccepted');
      setIsOrderAcceptedVal(isOrderAccepted);
      setVehicleData(fetchedData.podetaildata['Vehicle'] || []);
      setAccessoryData(fetchedData.podetaildata['Accessories'] || []);
      setSparePartData(fetchedData.podetaildata['Spare-Parts'] || []);
      setPoDetailsID(
        fetchedData?.podetaildata?.['Spare-Parts']?.[0]?.po_details_id,
      );
    } catch (error) {
      console.error('Error fetching order details:', error);
    }
  };

  console.log(poStatusVal, 'postatusVal');

  const handleModalClose = () => {
    setShowModal(false);
    setFormData({});
    setSuccessVal(0);
    setErrorVal(0);
  };

  const handleIndividualRejectModalClose = () => {
    setRejectModal(false);
  };

  const handleDamageChange = (e) => {
    const value = Number(e.target.value);
    setDamagedQty(value);
    setOrderFormData(
      Array(value).fill({ serial_no: '', chassis_no: '', vin_no: '' }),
    );
  };
  console.log('acceptorderformdata', formData);

  const handleExport = async (item) => {
    console.log(item.po_details_id, 'itemData>>>>>');

    try {
      const response = await axiosInstance.get(
        `/download-posrnoupdate/${item.po_details_id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          responseType: 'blob',
        },
      );
      console.log(response, 'resposne');

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'sample.csv');

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error('Error accepting order:', error);
      alert('Failed to accept order');
    }
  };

  const handledownload = async () => {
    try {
      const response = await axiosInstance.get(
        `/download-sample-posrnoupdate/${podetailsid}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          responseType: 'blob', // Set response type to blob for file downloads
        },
      );

      // Create a URL for the file blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element
      const link = document.createElement('a');
      link.href = url;

      // Set the file name for the download to .csv
      link.setAttribute('download', 'sample.csv'); // Changed to .csv

      // Append the link to the body (required for some browsers)
      document.body.appendChild(link);

      // Programmatically trigger the click event on the link
      link.click();

      // Clean up the link after download
      document.body.removeChild(link);
    } catch (error) {
      console.log(error);
    }
  };
  const UploadInputs = [
    {
      name: 'uploadDocument',
      label: ' ',
      type: 'uploadCsvOrderManagement',
      required: true,
      gridClass: 'col-lg-6',
      //validation:{required:true}
    },
  ];

  const readCSVFile = (file, callback) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const rows = data.split('\n').map((row) => row.split(','));
      setUploadedHeaders(rows[0]); // Save headers for downloading successful records
      callback(rows);
    };
    reader.readAsText(file); // Read as text for CSV
  };

  const downloadRowsCSV = (rows, headers, filename) => {
    // Ensure rows is an array of arrays
    if (!Array.isArray(rows) || !rows.every((row) => Array.isArray(row))) {
      console.error('Invalid data format for CSV download:', rows);
      return;
    }

    const finalData = [headers, ...rows];
    const csvContent = finalData.map((row) => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', filename); // Set the download file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const UploadInputss = [
    {
      name: 'invoice_oem_image',
      label: 'Invoice',
      type: 'file',
      required: true,
      gridClass: 'col-lg-8',
      validation: { required: true },
    },
    {
      name: 'invoice_number',
      label: 'Invoice Number',
      placeholder: 'Enter invoice number',
      type: 'text',
      required: true,
      gridClass: 'col-lg-8',
      validation: validations.invoiceNumber({ required: true }),
    },
    {
      name: 'mode_of_transportation',
      label: 'Mode of transportation',
      placeholder: 'Enter mode of transportation',
      type: 'text',
      required: true,
      gridClass: 'col-lg-8',
      validation: validations.modeOfTransportation({ required: true }),
    },
    {
      name: 'invoice_remark',
      label: 'Invoice Remark',
      placeholder: 'Enter invoice remark',
      type: 'text',
      required: true,
      gridClass: 'col-lg-8',
      validation: validations.invoiceRemark({ required: true }),
    },
    {
      name: 'oem_invoice_date',
      label: 'Invoice Date',
      type: 'date',
      maxDate: new Date(),
      // required: true,

      gridClass: 'col-12 col-lg-8',
    },
  ];

  const handleSubmit = async (formData) => {
    console.log('clicked');

    const errors = {};
    let isValid = true;

    UploadInputss.forEach((field) => {
      const value = formData[field.name];

      if (field.validation?.required && !value) {
        errors[field.name] = 'This field is required';
        isValid = false;
        return;
      }

      if (
        value &&
        field.validation?.pattern &&
        !field.validation.pattern.test(value)
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
        return;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // Create a FormData object
    const formDataPayload = new FormData();

    formDataPayload.append('po_id', data.po_id);
    formDataPayload.append('oem_invoice_date', formData.oem_invoice_date);
    formDataPayload.append('invoice_remark', formData.invoice_remark);
    formDataPayload.append(
      'mode_of_transportation',
      formData.mode_of_transportation,
    );
    formDataPayload.append('invoice_number', formData.invoice_number);

    // Append the image file if it exists
    if (formData.invoice_oem_image instanceof File) {
      formDataPayload.append('invoice_oem_image', formData.invoice_oem_image);
    }

    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you upload the file?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const response = await axiosInstance.post(
            `/purchaseorder/uploadoeminvoicedetails`,
            formDataPayload,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log(response, 'response');
          if (response.status === 200) {
            fetchOrderDetails();
            closeAcceptModal();
            setFormData({});
          }
        } catch (error) {
          console.log(error?.response?.data?.message, 'errorresponse');

          const errorMessage = error?.response?.data?.message;
          console.log(errorMessage, 'errorMessage');

          showErrorAlert({
            title: 'Warning',
            text: errorMessage || 'Something went wrong',
            callback: () => {
              console.log('Error alert confirmed');
            },
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // setLoading(false);
    }
  };

  const downloadFailedRowsCSV = (uploadedFile, failedRows) => {
    readCSVFile(uploadedFile, (csvData) => {
      const headers = [...csvData[0], 'ErrorMessage'];

      const failedRowsData = failedRows.map((errorRow) => {
        const originalRow = csvData[errorRow.lineNumber] || [];
        const errorMessage = errorRow.message || 'Error';
        return [...originalRow, errorMessage];
      });
      downloadRowsCSV(failedRowsData, headers, 'failed_records.csv'); // Trigger download
    });
  };
  const handleFormSubmit = async (formData) => {
    setIsButtonDisabled(true);
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataToSend = new FormData();
          formDataToSend.append('bulksrnoUpload', formData.uploadDocument);
          // formDataToSend.append('accepted_qty', 3);

          console.log(formData, 'uploadedDocument');
          const response = await axiosInstance.patch(
            `/podetails/acceptpodetail/${podetailsid}`,
            formDataToSend,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          console.log(response?.data?.data, 'DAtavalues');

          const { errors, success } = response.data.data;

          console.log(errors.length, 'errors');
          setErrorVal(errors.length);

          setSuccessVal(success.length);

          // const validCount = response.data.data.validCount
          // console.log(validCount, "validCount")
          // setValidCountData(validCount)

          // const inValidCount = response.data.data.invalidCount
          // console.log(inValidCount, "validCount")
          // setInValidCountData(inValidCount)

          const failedRows = response.data.data.errors;
          setFailedRows(failedRows);

          console.log(response.data.data, 'success');

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'File added successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              //   navigate("/manage-services/check-warranty");
            });
            fetchOrderDetails();
            // handleModalClose();
          }
        } catch (error) {
          // Error Alert
          Swal.fire({
            title: 'Error',
            text: 'Failed to upload file. Please try again.',
            icon: 'error',
            confirmButtonText: 'OK',
          });
        }
      },
    });
    if (!result.isConfirmed) {
      setIsButtonDisabled(false);
    }
  };

  const DamagedInputs = () => {
    console.log('damagedformdata', formData);

    // if (orderformData?.length > 0) {
    return (
      <div className="mb-3">
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
          }}
          className="col-lg-12"
        >
          <div
            style={{ borderRadius: '30px' }}
            className="downloadiconwrapperr"
            onClick={handledownload}
          >
            <a
              style={{ fontSize: '15px', cursor: 'pointer' }}
              className="downloadHeading"
            >
              Download File Sample
            </a>
            {/* <img src={downloadIcon} alt='download' className="downloadImg" /> */}
          </div>
          <div>
            <DynamicForm
              formConfig={UploadInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />
          </div>
        </div>
      </div>
    );
    //   }

    // else{
    //     return orderformData?.map((item, index) => (
    //         <div key={index} className="d-flex flex-wrap align-items-center mb-3 gap-4">
    //             {selectedItemType === 'Vehicle' ? (
    //                 <>
    //                     <div className="col-lg-4">
    //                         <label>Vin No.</label>
    //                         <input
    //                             type="text"
    //                             className="form-control"
    //                             placeholder="Enter Vin No."
    //                             value={item.vin_no}
    //                             onChange={(e) => handleInputChange(index, 'vin_no', e.target.value)}
    //                         />
    //                     </div>
    //                     <div className="col-lg-4">
    //                         <label>Chassis No.</label>
    //                         <input
    //                             type="text"
    //                             className="form-control"
    //                             placeholder="Enter Chassis No."
    //                             value={item.chassis_no}
    //                             onChange={(e) => handleInputChange(index, 'chassis_no', e.target.value)}
    //                         />
    //                     </div>
    //                 </>
    //             ) : (
    //                 <div className="col-lg-12">
    //                     <label>Serial No.</label>
    //                     <input
    //                         type="text"
    //                         className="form-control"
    //                         placeholder="Enter Serial No."
    //                         value={item.serial_no}
    //                         onChange={(e) => handleInputChange(index, 'serial_no', e.target.value)}
    //                     />
    //                 </div>
    //             )}
    //         </div>
    //     ));
    // }
  };

  const handledatePopUp = (item, type) => {
    console.log('clicked', item);
    setSelectedItemType(type);
    setShowDateModal(true);
    setSelectedItem(item);
    // handleCheckStocks(item);
    console.log(type, 'selectitemtype');
    console.log(item, 'itemssssss>>>>>');

    console.log(selectedItem, 'itemDetails');
  };

  const handleBulkdatePopUp = (item, type) => {
    console.log('clicked', item);
    setSelectedItemType(type);
    setBulkExpectedDeliveryDate(true);
    setSelectedItem(item);
    // handleCheckStocks(item);
    console.log(type, 'selectitemtype');
    console.log(item, 'itemssssss>>>>>');

    console.log(selectedItem, 'itemDetails');
  };

  const handleRejectModalPopupClose = () => {
    setRejectModalPopup(false);
  };

  const handleCloseBatteryModal = () => {
    setBatteryModal(false);
  };

  const handleAcceptBatteryNumbers = async () => {
    try {
      const requiredQty = Number(batteryDetails?.total_battery_qty || 0);

      // remove empty / undefined values
      const filledBatteries = batteryNumbers.filter(
        (num) => num && num.trim() !== '',
      );

      // ❌ REQUIRED validation
      if (filledBatteries.length !== requiredQty) {
        alert(
          'Please fill all battery serial number fields before submitting.',
        );
        return;
      }

      // ❌ DUPLICATE validation
      const uniqueSet = new Set(filledBatteries);
      if (uniqueSet.size !== filledBatteries.length) {
        alert('Battery serial numbers must be unique.');
        return;
      }

      const payload = {
        PoId: data?.po_id,
        Item: batteryDetails?.battryName,
        total_battery_qty: batteryDetails?.total_battery_qty,
        BatteryNo: batteryNumbers.filter(Boolean),
      };

      const response = await axiosInstance.post(
        `/podetails/acceptbatterynumber`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const closeModalFlag = response?.data?.data?.closeModal ?? 0;

      if (response?.status === 200) {
        Swal.fire({
          title: 'Success',
          text: 'Battery Added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        fetchOrderDetails();
        setBatteryModal(false);
        setPoDetails((p) => ({ ...(p || {}), battery_closed: closeModalFlag }));
        if (closeModalFlag === 1 && data?.po_id) {
          try {
            localStorage.setItem(`battery_closed_${data.po_id}`, '1');
          } catch (e) {
            // ignore localStorage errors
            console.error('localStorage error', e);
          }
        }

        // clear inputs/errors after success
        setBatteryNumbers([]);
        setBatteryErrors([]);
        setTimeout(() => {
          fetchOrderDetails();
        }, 4000);
      }
    } catch (error) {
      // console.error("API Error:", error?.response?.data?.message);
      // const errorMessage = error?.response?.data?.message
      // Swal.fire({
      //   title: "Error",
      //   text:errorMessage|| "Failed to approve order. Please try again.",
      //   icon: "error",
      //   confirmButtonText: "OK",
      // });

      const mainMessage =
        error?.response?.data?.message || 'Something went wrong';

      const errorList = error?.response?.data?.data || [];

      // Convert array messages to HTML list
      const errorHtml =
        errorList.length > 0
          ? `<ul style="text-align:left;">
          ${errorList
            .map((err) => `<li>Line ${err.lineNumber}: ${err.message}</li>`)
            .join('')}
        </ul>`
          : '';

      Swal.fire({
        title: 'Error',
        html: `<p>${mainMessage}</p>${errorHtml}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  const isBatteryClosedPersisted =
    poDetails?.battery_closed === 1 ||
    (data?.po_id &&
      localStorage.getItem(`battery_closed_${data.po_id}`) === '1');

  const handleRejectPopUp = (item, type) => {
    setSelectedItemType(type);
    setRejectModalPopup(true);
    setSelectedItem(item);
    console.log(type, 'selectitemtype');
    console.log(item, 'itemssssss>>>>>');

    console.log(selectedItem, 'itemDetails');
  };

  const closeDateModal = () => {
    setExpectedDate(null);
    setShowDateModal(false);
  };

  const closeBulkDateModal = () => {
    setExpectedDate(null);
    setBulkExpectedDeliveryDate(false);
  };

  const handleRequestForReturn = (item, type) => {
    setSelectedItemType(type);
    handleCheckStocks(item);
    setShowModal(true);
    setSelectedItem(item);
    fetchPoNumberUpdate(item);
    console.log(type, 'selectitemtype');
    console.log(item, 'itemssssss>>>>>');

    console.log(selectedItem, 'itemDetails');
  };

  const handleRejectModalforReturn = (item, type) => {
    setSelectedItemType(type);
    setRejectModal(true);
  };

  const handleRejectIndividualOrder = async () => {
    const payload = {
      remark: rejectRemark,
    };

    try {
      const response = await axiosInstance.patch(
        `/purchaseorder/rejectorderitem/${podetailsid}`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      if (response.status === 200) {
        alert('Order rejected successfully');
        // handleModalClose();
        fetchOrderDetails();
        setRejectModal(false);
      }
    } catch (error) {
      console.error('Error accepting order:', error);
      alert('Failed to accept order');
    }
  };

  // const handleAcceptOrder = async () => {
  //     const payload = {
  //         accepted_qty: damagedQty,
  //         srnoarray: orderformData.map((item) =>
  //             selectedItemType === 'Vehicle'
  //                 ? { chassis_no: item.chassis_no, vin_no: item.vin_no }
  //                 : { serial_no: item.serial_no }
  //         ),
  //     };

  //     try {
  //         const response = await axiosInstance.patch(`/podetails/acceptpodetail/${podetailsid}`, payload, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //                 Authorization: `Bearer ${authToken}`,
  //             },
  //         });
  //         if (response.status === 200) {
  //             alert('Order accepted successfully');
  //             handleModalClose();
  //             fetchOrderDetails();
  //         }
  //     } catch (error) {
  //         console.error('Error accepting order:', error);
  //         alert('Failed to accept order');
  //     }
  // };

  const itemLabels = {
    Vehicle: [
      { label: 'Name', key: 'name' },
      // { label: 'PO Detail No.', key: 'podetail_number' },
      // { label: 'Type', key: 'itemtypename' },
      // { label: 'Color', key: 'color' },
      { label: 'Make', key: 'make_name' },
      { label: 'Model', key: 'model_name' },
      { label: 'Variant', key: 'variant_name' },
      // { label: 'Price', key: 'totalprice' },

      { label: 'Order Quantity', key: 'quantity' },
      { label: 'Approved Quantity', key: 'accepted_qty' },
      { label: 'Approved Quantity By Dealer', key: 'quantity_approval_dealer' },
      { label: 'Base Price', key: 'rate' },
      { label: 'Tax', key: 'tax' },
      { label: 'Tax Amount', key: 'taxset_amount' },
      { label: 'Price', key: 'totalprice' },
      { label: 'Job Card Number', key: 'job_card_number' },
      { label: 'Variant Remark', key: 'variant_remark' },
      // variant_remark
      { label: 'Expected Date', key: 'po_expected_date' },
      { label: 'Remark', key: 'rejected_remark' },
    ],
    Accessories: [
      { label: 'Name', key: 'name' },
      { label: 'PO Detail No.', key: 'podetail_number' },
      { label: 'Type', key: 'itemtypename' },
      { label: 'Color', key: 'color' },
      // { label: 'Price', key: 'totalprice' },
      { label: 'Model', key: 'model_name' },
      { label: 'Order Quantity', key: 'quantity' },
      { label: 'Approved Quantity', key: 'accepted_qty' },
      { label: 'Approved Quantity By Dealer', key: 'quantity_approval_dealer' },
      { label: 'Rate', key: 'rate' },
      { label: 'Tax', key: 'tax' },
      { label: 'Tax Amount', key: 'taxset_amount' },
      { label: 'Job Card Number', key: 'job_card_number' },
      { label: 'Price', key: 'totalprice' },
      { label: 'Expected Date', key: 'po_expected_date' },
      { label: 'Remark', key: 'rejected_remark' },
    ],
    'Spare-Parts': [
      { label: 'Name', key: 'name' },
      { label: 'PO Detail No.', key: 'podetail_number' },
      { label: 'Part Number', key: 'part_number' },
      { label: 'Type', key: 'itemtypename' },
      { label: 'Model', key: 'model_name' },
      { label: 'Color', key: 'color_name' },
      // { label: 'Price', key: 'totalprice' },
      { label: 'Order Quantity', key: 'quantity' },
      { label: 'Approved Quantity', key: 'accepted_qty' },
      { label: 'Approved Quantity By Dealer', key: 'quantity_approval_dealer' },
      { label: 'Job Card Number', key: 'job_card_number' },
      { label: 'Rate', key: 'rate' },
      { label: 'Tax', key: 'tax' },
      { label: 'Tax Amount', key: 'taxset_amount' },

      { label: 'Price', key: 'totalprice' },
      { label: 'Expected Date', key: 'po_expected_date' },
      { label: 'Remark', key: 'rejected_remark' },
    ],
  };

  // const renderItemRow = (item, setData, data, type) => {
  //     const labels = itemLabels[type] || [];
  //    // setpodetailsid(item?.po_details_id)

  //     return (
  //         <div className="d-flex flex-wrap align-items-start p-3 mb-3 gap-4" key={item.po_details_id}>
  //             {labels.map((field, index) => (
  //                 item[field.key] !== undefined && item[field.key] !== null && (
  //                     <div className="d-flex flex-column me-4 gap-2" key={index}>
  //                         <h6 className="text-muted">{field.label}</h6>
  //                         <span>{item[field.key] !== '' ? item[field.key] : 'N/A'}</span>
  //                     </div>
  //                 )
  //             ))}

  //             {/* {item.is_accepted === 1 ? (
  //                 <button
  //                     className="btn btn-outline-info ms-auto"
  //                     onClick={() => {fetchSerialDetails(item?.po_details_id, type);setpodetailsid(item.po_details_id)}}
  //                 >
  //                     View
  //                 </button>
  //             ) : (
  //                 <button
  //                     className="btn btn-outline-success ms-auto"
  //                     onClick={() => {handleRequestForReturn(item, type);setpodetailsid(item.po_details_id)}}
  //                 >
  //                     Update Quantity
  //                 </button>
  //             )} */}

  //             {/* Handle Reject Api */}

  //             {/* {
  //                 item.is_accepted === 0  ? (
  //                     <button
  //                     className="btn btn-outline-success ms-auto"
  //                     onClick={() => {
  //                         handleRejectModalforReturn(item, type);
  //                     setpodetailsid(item.po_details_id);
  //                     }}
  //                 >
  //                     Reject
  //                 </button>
  //                 ) : null
  //             } */}

  //             {item.is_accepted === 1 && item.delivered_qty > 0 ? (
  //                 <button
  //                     className="btn btn-outline-info ms-auto"
  //                     onClick={() => {
  //                     fetchSerialDetails(item?.po_details_id, type);
  //                     setpodetailsid(item.po_details_id);
  //                     }}
  //                 >
  //                     View
  //                 </button>
  //                 ) : item.is_accepted === 1  ? (
  //                 <button
  //                     className="btn btn-outline-success ms-auto"
  //                     onClick={() => {
  //                     handleRequestForReturn(item, type);
  //                     setpodetailsid(item.po_details_id);
  //                     }}
  //                 >
  //                     Upload Product Details
  //                 </button>
  //                 ) : item.is_accepted === 2 ? (
  //                     <button
  //                     style={{background:"red", color:"white", border:"1px solid white"}}
  //                     className="btn btn-outline-info ms-auto"
  //                 >
  //                     Rejected
  //                 </button>
  //                 ) : null}
  //         </div>
  //     );
  // };
  // Define the table headers

  // const handleExport = async (item) => {
  //     console.log(item.po_details_id, "itemData>>>>>")

  //     try {
  //         const response = await axiosInstance.get(`/download-posrnoupdate/${item.po_details_id}`, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //                 Authorization: `Bearer ${authToken}`,
  //             },
  //         });
  //         console.log(response, "resposne")
  //     } catch (error) {
  //         console.error('Error accepting order:', error);
  //         alert('Failed to accept order');
  //     }
  // }

  // const renderTable = (data, setData, type) => {
  //     const labels = itemLabels[type] || [];

  //     // Inline styles
  //     const tableStyle = {
  //         width: '100%',
  //         borderCollapse: 'collapse',
  //         marginTop: '20px',
  //     };

  //     const headerCellStyle = {
  //         fontSize: '14px',
  //         fontWeight: 'bold',
  //         borderBottom: '1px solid lightgray',
  //         padding: '8px',
  //         textAlign: 'left',
  //         paddingLeft: '15px',
  //     };

  //     const dataCellStyle = {
  //         fontSize: '14px',
  //         borderBottom: '1px solid lightgray',
  //         padding: '8px',
  //         verticalAlign: 'middle',
  //         backgroundColor: 'transparent',
  //     };

  //     const actionCellStyle = {
  //         ...dataCellStyle,
  //         textAlign: 'left',
  //     };

  //     return (
  //         <table style={tableStyle}>
  //             <thead>
  //                 <tr>
  //                     {labels.map((label, index) => (
  //                         <th key={index} style={headerCellStyle}>
  //                             {label.label}
  //                         </th>
  //                     ))}
  //                     <th style={headerCellStyle}>Action</th>
  //                 </tr>
  //             </thead>
  //             <tbody>
  //                 {data.map((item) => (
  //                     <tr key={item.po_details_id}>
  //                         {labels.map((field, index) =>
  //                             field.key === 'quantity' ? (
  //                                 <td key={index} style={dataCellStyle}>
  //                                     {/* Display Quantity and Export Button */}
  //                                     <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
  //                                         <span>{item[field.key]}</span>
  //                                         {
  //                                             item.is_accepted === 1 ? (
  //                                                 <button
  //                                                 className="btn btn-outline-success"
  //                                                 style={{
  //                                                     marginLeft: '10px',
  //                                                     borderRadius: '20px',
  //                                                     fontSize: '13px',
  //                                                 }}
  //                                                 onClick={() => handleExport(item)} // Replace with your export function
  //                                             >
  //                                                 Export
  //                                             </button>
  //                                             ): null
  //                                         }

  //                                     </div>
  //                                 </td>
  //                             ) : (
  //                                 <td key={index} style={dataCellStyle}>
  //                                     {item[field.key] !== undefined && item[field.key] !== null
  //                                         ? item[field.key]
  //                                         : 'N/A'}
  //                                 </td>
  //                             )
  //                         )}
  //                         {/* <td style={actionCellStyle}>

  //                             {item.is_accepted === 1 && item.delivered_qty > 0 ? (
  //                                 <button
  //                                     className="btn btn-outline-info"
  //                                     onClick={() => {
  //                                         fetchSerialDetails(item.po_details_id, type);
  //                                         setpodetailsid(item.po_details_id);
  //                                     }}
  //                                 >
  //                                     View
  //                                 </button>
  //                             ) : item.is_accepted === 1 ? (
  //                                 <button
  //                                     className="btn btn-outline-success
  //                                     onClick={() => {
  //                                         handleRequestForReturn(item, type);
  //                                         setpodetailsid(item.po_details_id);
  //                                     }}
  //                                 >
  //                                     Update Qty
  //                                 </button>
  //                             ) : item.is_accepted === 2 ? (
  //                                 <button
  //                                     style={{
  //                                         background: 'red',
  //                                         color: 'white',
  //                                         border: '1px solid white',
  //                                     }}
  //                                     className="btn btn-danger"
  //                                     disabled
  //                                 >
  //                                     Rejected
  //                                 </button>
  //                             ) : null}
  //                         </td> */}
  //                         <td style={actionCellStyle}>
  //                         {/* Render Action Buttons */}
  //                         {item.is_accepted === 1 && item.delivered_qty > 0 ? (
  //                             <button
  //                                 className="btn btn-outline-info"
  //                                 onClick={() => {
  //                                     fetchSerialDetails(item.po_details_id, type);
  //                                     setpodetailsid(item.po_details_id);
  //                                 }}
  //                             >
  //                                 View
  //                             </button>
  //                         ) : item.is_accepted === 1 ? (
  //                             <button
  //                                 className="btn btn-outline-success
  //                                 onClick={() => {
  //                                     handleRequestForReturn(item, type);
  //                                     setpodetailsid(item.po_details_id);
  //                                 }}
  //                             >
  //                                 Update Qty
  //                             </button>
  //                         ) : item.is_accepted === 2 ? (
  //                             <button
  //                                 style={{
  //                                     background: 'red',
  //                                     color: 'white',
  //                                     border: '1px solid white',
  //                                 }}
  //                                 className="btn btn-danger"
  //                                 disabled
  //                             >
  //                                 Rejected
  //                             </button>
  //                         ) : (
  //                             // Placeholder when no button is rendered
  //                             <span style={{ color: 'gray', fontStyle: 'italic' }}>No actions to perform</span>
  //                         )}
  //                     </td>
  //                     </tr>
  //                 ))}
  //             </tbody>
  //         </table>
  //     );
  // };
  const isSpareOrAccessory = selectedItemType;
  const allowAlphaNumericOnly = (value) => {
    return value.replace(/[^a-zA-Z0-9]/g, '');
  };

  const renderTable = (data, setData, type) => {
    const labels = itemLabels[type] || [];

    // Inline styles
    const tableStyle = {
      width: '100%',
      borderCollapse: 'collapse',
      marginTop: '20px',
    };

    const headerCellStyle = {
      fontSize: '14px',
      fontWeight: 'bold',
      borderBottom: '1px solid lightgray',
      padding: '8px',
      textAlign: 'left',
      paddingLeft: '15px',
    };

    const dataCellStyle = {
      fontSize: '14px',
      borderBottom: '1px solid lightgray',
      padding: '8px',
      verticalAlign: 'middle',
      backgroundColor: 'transparent',
      // display: "flex",
      // gap:"10px",
      // alignItems:"center"
    };

    const actionCellStyle = {
      ...dataCellStyle,
      textAlign: 'left',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    };

    const toggleEdit = (item, setData) => {
      setData((prevData) =>
        prevData.map((d) =>
          d.po_details_id === item.po_details_id
            ? { ...d, editable: !d.editable }
            : d,
        ),
      );
    };

    // const handleSave = async (item, setData) => {
    //   // Save logic can be implemented here (e.g., API call)
    //   console.log("Saved item:", item);

    //   try {
    //     // API call to save the damaged quantity
    //     await axiosInstance.patch(
    //       `/podetails/updateAcceptQuantity/${item?.po_details_id}`,
    //       {
    //         accepted_qty: item.accepted_qty,
    //         is_order_accepted: poStatusVal === "Approved" ? 1 : 8,
    //         //  is_order_accepted: poDetails?.is_order_accepted === 0 ? 8 : 8,
    //       },
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${authToken}`,
    //         },
    //       },
    //     );
    //     // Toggle edit mode off after saving
    //     // Disable editing after saving
    //     setData((prevData) =>
    //       prevData.map((d) =>
    //         d.po_details_id === item.po_details_id
    //           ? { ...d, editable: false }
    //           : d,
    //       ),
    //     );
    //     fetchOrderDetails(); // Refresh data after saving
    //   } catch (error) {
    //     console.error("Error updating damaged quantity:", error);
    //     console.error("Error submitting form:", error.response?.data?.data);

    //     // Error alert
    //     const errorMessage = error.response?.data?.data;
    //     showErrorAlert({
    //       title: errorMessage || "Something went wrong",
    //       // text:
    //       //   errorMessage || "An error occurred while processing your request.",
    //       callback: () => {
    //         console.log("Error alert confirmed");
    //       },
    //     });
    //   }
    // };

    const handleSave = async (item, setData) => {
      // ✅ Validation check
      if (
        item?.accepted_qty === null ||
        item?.accepted_qty === undefined ||
        item?.accepted_qty === ''
      ) {
        showErrorAlert({
          title: 'Quantity is required',
          callback: () => {
            console.log('Validation alert confirmed');
          },
        });
        return; // ❌ stop API call
      }

      console.log('Saved item:', item);

      try {
        await axiosInstance.patch(
          `/podetails/updateAcceptQuantity/${item?.po_details_id}`,
          {
            accepted_qty: item.accepted_qty,
            is_order_accepted: poStatusVal === 'Approved' ? 1 : 8,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
          },
        );

        setData((prevData) =>
          prevData.map((d) =>
            d.po_details_id === item.po_details_id
              ? { ...d, editable: false }
              : d,
          ),
        );

        fetchOrderDetails();
      } catch (error) {
        console.error('Error updating damaged quantity:', error);

        const errorMessage = error.response?.data?.data;
        showErrorAlert({
          title: errorMessage || 'Something went wrong',
          callback: () => {
            console.log('Error alert confirmed');
          },
        });
      }
    };

    return (
      <table style={tableStyle}>
        <thead>
          <tr>
            {labels.map((label, index) => (
              <th key={index} style={headerCellStyle}>
                {label.label}
              </th>
            ))}
            <th style={headerCellStyle}>Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.po_details_id}>
              {labels.map((field, index) => (
                <td key={index} style={dataCellStyle}>
                  {field.key === 'accepted_qty' ? (
                    <div className="d-flex align-items-center">
                      {item.is_accepted === 1 || item.is_accepted === 2 ? (
                        item.editable ? (
                          <>
                            <input
                              type="number"
                              value={item.accepted_qty}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Allow clearing
                                if (val === '') {
                                  setError('');
                                  setData((prevData) =>
                                    prevData.map((d) =>
                                      d.po_details_id === item.po_details_id
                                        ? { ...d, accepted_qty: '' }
                                        : d,
                                    ),
                                  );
                                  return;
                                }

                                // Allow only positive integers
                                if (!/^[1-9][0-9]*$/.test(val)) {
                                  setError('Only positive numbers allowed');
                                  return;
                                }

                                // Validate max input
                                // if (Number(val) > Number(item.quantity)) {
                                //   setError(
                                //     `Value cannot be more than ${item.quantity}`,
                                //   );
                                //   return;
                                // }

                                // Valid input → update value
                                setError('');
                                setData((prevData) =>
                                  prevData.map((d) =>
                                    d.po_details_id === item.po_details_id
                                      ? { ...d, accepted_qty: val }
                                      : d,
                                  ),
                                );
                              }}
                              className="form-control"
                              style={{ width: '60px', height: '30px' }}
                            />
                            {error && (
                              <small
                                style={{
                                  color: 'red',
                                  display: 'block',
                                  marginTop: '4px',
                                  marginLeft: '10px',
                                }}
                              > 
                                {error}
                              </small>
                            )}
                            <button
                              className="btn btn-success ms-2"
                              onClick={() => handleSave(item, setData)}
                            >
                              Save
                            </button>
                          </>
                        ) : (
                          <div>
                            {/* <span>{item.accepted_qty ?? 0}</span> */}

                            <span>
                              {/* {item.rejected_remark &&
                              item.rejected_remark !== "--"
                                ? 0
                                : item.accepted_qty ?? 0} */}
                              <span>
                                {item.rejected_remark &&
                                item.rejected_remark !== '--' &&
                                !item.quantity_approval_dealer
                                  ? 0
                                  : (item.accepted_qty ?? 0)}
                              </span>
                            </span>
                            {item.delivered_qty > 0 && item.vin_no ? (
                              <button
                                className="btn btn-outline-success"
                                style={{
                                  marginLeft: '10px',
                                  borderRadius: '20px',
                                  fontSize: '13px',
                                }}
                                onClick={() => handleExport(item)} // Replace with your export function
                              >
                                Export
                              </button>
                            ) : null}
                            {!(
                              item.is_accepted === 1 && item.delivered_qty > 0
                            ) &&
                              !item.vin_no &&
                              poStatusVal !== 'Partial Delivered' && (
                                <FaEdit
                                  className="text-primary ms-2"
                                  style={{
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => toggleEdit(item, setData)}
                                />
                              )}
                          </div>
                        )
                      ) : item.is_accepted === 0 ? (
                        item.editable ? (
                          <>
                            <input
                              type="number"
                              value={item.accepted_qty}
                              onChange={(e) => {
                                const val = e.target.value;

                                // Allow clearing
                                if (val === '') {
                                  setError('');
                                  setData((prevData) =>
                                    prevData.map((d) =>
                                      d.po_details_id === item.po_details_id
                                        ? { ...d, accepted_qty: '' }
                                        : d,
                                    ),
                                  );
                                  return;
                                }

                                // Allow only positive integers
                                if (!/^[1-9][0-9]*$/.test(val)) {
                                  setError('Only positive numbers allowed');
                                  return;
                                }

                                // Validate max input
                                // if (Number(val) > Number(item.quantity)) {
                                //   setError(
                                //     `Value cannot be more than ${item.quantity}`,
                                //   );
                                //   return;
                                // }

                                // Valid input → update value
                                setError('');
                                setData((prevData) =>
                                  prevData.map((d) =>
                                    d.po_details_id === item.po_details_id
                                      ? { ...d, accepted_qty: val }
                                      : d,
                                  ),
                                );
                              }}
                              className="form-control"
                              style={{ width: '60px', height: '30px' }}
                            />
                            {error && (
                              <small
                                style={{
                                  color: 'red',
                                  display: 'block',
                                  marginTop: '4px',
                                  marginLeft: '10px',
                                }}
                              >
                                {error}
                              </small>
                            )}
                            <button
                              className="btn btn-success ms-2"
                              onClick={() => handleSave(item, setData)}
                            >
                              Save
                            </button>
                          </>
                        ) : (
                          <>
                            {/* <span>{item.accepted_qty ?? 0}</span> */}

                            <span>
                              {/* {item.rejected_remark &&
                              item.rejected_remark !== "--"
                                ? 0
                                : item.accepted_qty ?? 0} */}
                              <span>
                                {item.rejected_remark &&
                                item.rejected_remark !== '--' &&
                                !item.quantity_approval_dealer
                                  ? 0
                                  : (item.accepted_qty ?? 0)}
                              </span>
                            </span>
                            {!(
                              item.is_accepted === 1 && item.delivered_qty > 0
                            ) &&
                              !item.vin_no &&
                              poStatusVal !== 'Partial Delivered' && (
                                <FaEdit
                                  className="text-primary ms-2"
                                  style={{
                                    cursor: 'pointer',
                                  }}
                                  onClick={() => toggleEdit(item, setData)}
                                />
                              )}
                          </>
                        )
                      ) : null}
                    </div>
                  ) : item[field.key] !== undefined &&
                    item[field.key] !== null ? (
                    item[field.key]
                  ) : (
                    '--'
                  )}
                </td>
              ))}
              {/* <td style={actionCellStyle}>
                {item.is_accepted === 1 && item.delivered_qty > 0 ? (
                  <button
                    className="btn btn-outline-info"
                    onClick={() => {
                      fetchSerialDetails(item.po_details_id, type);
                      setpodetailsid(item.po_details_id);
                    }}
                  >
                    View
                  </button>
                ) : null}

           
                {item.rejected_remark === null &&
                (poStatusVal === "Pending" ||
                  poStatusVal === "Modified" ||
                  poStatusVal === "Re-Submitted") ? (
                  <button
                    style={{
                      background: "#fff",
                      color: "red",
                      // border: '1px solid white',
                    }}
                    className="btn btn-danger"
                    onClick={() => {
                      handleRejectPopUp(item, type);
                      setpodetailsid(item.po_details_id);
                    }}
                  >
                    <GiCancel />
                  </button>
                ) : null}

                {(item.po_expected_date === null ||
                  item.po_expected_date !== null) &&
                item.rejected_remark === null &&
                orderAcceptedVal !== 2 &&
                (poStatusVal === "Pending" ||
                  poStatusVal === "Modified" ||
                  poStatusVal === "Re-Submitted") ? (
                  <button
                    className="btn btn-outline-info"
                    onClick={() => {
                      handledatePopUp(item, type);
                      setpodetailsid(item.po_details_id);
                    }}
                  >
                    <FaCalendarAlt />
                  </button>
                ) : null}
              
                {poStatusVal !== "Cancelled" &&
                item.is_accepted === 1 &&
                item.delivered_qty < item.accepted_qty ? (
                  <button
                    className="btn btn-outline-success
                    onClick={() => {
                      handleRequestForReturn(item, type);
                      setpodetailsid(item.po_details_id);
                    }}
                  >
                    Update Qty
                  </button>
                ) : item.is_accepted === 2 ? (
                  <button
                    style={{
                      background: "red",
                      color: "white",
                      border: "1px solid white",
                    }}
                    className="btn btn-danger"
                    disabled
                  >
                    Rejected
                  </button>
                ) : (
                  ""
                )}
                {item.is_accepted === 0 || item.accepted_qty === 0 ? (
                  <span
                    style={{
                      color: "gray",
                      fontStyle: "italic",
                    }}
                  >
                   
                  </span>
                ) : null}
              </td> */}

              <td style={dataCellStyle}>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  {item.is_accepted === 1 && item.delivered_qty > 0 ? (
                    <button
                      className="btn btn-outline-info"
                      onClick={() => {
                        fetchSerialDetails(item.po_details_id, type);
                        setpodetailsid(item.po_details_id);
                      }}
                    >
                      View
                    </button>
                  ) : null}

                  {/* {item.rejected_remark === null || item.rejected_remark === "--"  &&
                  (poStatusVal === "Pending" ||
                    poStatusVal === "Modified" ||
                    poStatusVal === "Re-Submitted" || 
                    poStatusVal === "Approved"
                  ) ? (
                    <button
                      style={{ background: "#fff", color: "red" }}
                      className="btn btn-danger"
                      onClick={() => {
                        handleRejectPopUp(item, type);
                        setpodetailsid(item.po_details_id);
                      }}
                    >
                      <GiCancel />
                    </button>
                  ) : null} */}
                  {/* Partial Delivered */}
                  {(poStatusVal === 'Pending' ||
                    poStatusVal === 'Modified' ||
                    poStatusVal === 'Re-Submitted' ||
                    poStatusVal === 'Approved') &&
                  (item.rejected_remark === null ||
                    item.rejected_remark === '--') ? (
                    <button
                      style={{ background: '#fff', color: 'red' }}
                      className="btn btn-danger"
                      onClick={() => {
                        handleRejectPopUp(item, type);
                        setpodetailsid(item.po_details_id);
                      }}
                    >
                      <GiCancel />
                    </button>
                  ) : null}

                  {(item.po_expected_date === null ||
                    item.po_expected_date !== null) &&
                  item.rejected_remark === null &&
                  orderAcceptedVal !== 2 &&
                  (poStatusVal === 'Pending' ||
                    poStatusVal === 'Modified' ||
                    poStatusVal === 'Re-Submitted') ? (
                    <button
                      className="btn btn-outline-info"
                      onClick={() => {
                        handledatePopUp(item, type);
                        setpodetailsid(item.po_details_id);
                      }}
                    >
                      <FaCalendarAlt />
                    </button>
                  ) : null}

                  {poStatusVal !== 'Cancelled' &&
                  item.is_accepted === 1 && //Number(poDetails?.can_dispatch) === 1 &&
                  item.delivered_qty < item.accepted_qty &&
                  poDetails?.is_order_accepted <= 11 ? (
                    <button
                      className="btn btn-outline-success"
                      onClick={() => {
                        handleRequestForReturn(item, type);
                        setpodetailsid(item.po_details_id);
                      }}
                    >
                      Ready for Dispatch?
                    </button>
                  ) : item.is_accepted === 2 ? (
                    <button
                      style={{
                        background: 'red',
                        color: 'white',
                        border: '1px solid white',
                      }}
                      className="btn btn-danger"
                      disabled
                    >
                      Rejected
                    </button>
                  ) : (
                    ''
                  )}

                  {item.is_accepted === 0 || item.accepted_qty === 0 ? (
                    <span style={{ color: 'gray', fontStyle: 'italic' }}></span>
                  ) : null}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const TABLE_HEADERS =
    selectedItemType === 'Vehicle' ? ['VIN No', 'Engine No'] : ['Serial No'];

  // Define key mappings based on the selectedItemType
  const keyMapping =
    selectedItemType === 'Vehicle'
      ? {
          // "Chassis No": "chassis_no",
          'VIN No': 'vin_no',
          'Engine No': 'engine_no',
        }
      : {
          'Serial No': 'serial_no',
        };

  const fieldLabels = {
    po_number: 'PO No.',
    po_date: 'PO Date',
    dealer_name: 'Dealer Name',
    dealer_pin_code: 'PinCode',
    dealer_address: 'Address',
    estimated_delivery_date: 'Revised Date',
    po_expected_date: 'Dealer Expected Date',
    total: 'Total Price',
    approval_remark: 'Remark',
    postatus: 'Status',
    payment_status: 'Payment Status',
    image_path: 'Transaction Image',
    oem_invoice_number: 'Invoice Number',
    mode_of_transportation: 'Mode of transportation',
    // Add more fields here as needed...
  };
  const includedFields = [
    'po_number',
    'po_date',
    'dealer_name',
    'dealer_pin_code',
    'dealer_address',
    'postatus',
    'po_expected_date',
    'estimated_delivery_date',
    'approval_remark',
    'total',
    // "remark",
    'payment_status',
    'image_path',
    'oem_invoice_number',
    'mode_of_transportation',
  ];

  const handleRejectModalClose = () => {
    setShowRejectModal(false);
  };
  return (
    <div>
      <div
        style={{ paddingTop: '20px', borderBottom: '1px solid lightgray' }}
        className="header-container"
      >
        <div className="backbutton mt-2 mb-2">
          <img onClick={() => navigate(-1)} src={backicon} alt="back" />
          <span className="backbtntitle">Order Details</span>
        </div>

        {poDetails?.is_order_accepted === 3 ||
          (poDetails?.is_order_accepted === 1 && (
            // && poDetails?.oem_payment_status !== 1
            // )
            <div className="confirmation_btns">
              {/* <h5>Are you sure, dealer have done the full-payment</h5>
              <div className="yes_no_btns">
                <button onClick={onClickYes} className="flte-btnnn">
                  Yes
                </button>
                <button onClick={onClickNo} className="flte-btnnn">
                  No
                </button>
              </div> */}
            </div>
          ))}

        {/* poDetails?.oem_invoice_number  */}
        {/* {poDetails?.is_order_accepted === 3 ||
          ((
            poDetails?.is_order_accepted === 14 ||
            poDetails?.is_order_accepted === 1 ||
            poDetails?.is_order_accepted === 11) && (
            <button
              onClick={handleAcceptModalOpen}
              style={{ paddingLeft: "45px", paddingRight: "45px" }}
              className="submit-btn order-management-details"
            >
              Upload Attachment
            </button>
          ))} */}
        {(poDetails?.is_order_accepted === 3 ||
          poDetails?.is_order_accepted === 14 ||
          poDetails?.is_order_accepted === 5 ||
          poDetails?.is_order_accepted === 1 ||
          poDetails?.is_order_accepted === 11) &&
          poDetails?.oem_invoice_number === null && (
            <button
              onClick={handleAcceptModalOpen}
              style={{ paddingLeft: '45px', paddingRight: '45px' }}
              className="submit-btn order-management-details"
            >
              Upload Attachment
            </button>
          )}
        {acceptModal && (
          <div className="customModalOverlay">
            <div className="custom-modal-expectedDate">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Upload Attachment</h6>
                <button className="close-button" onClick={closeAcceptModal}>
                  ×
                </button>
              </div>
              <div
                style={{ height: '24rem', overflow: 'auto' }}
                className="custom-modal-body"
              >
                <DynamicForm
                  formConfig={UploadInputss}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: '#007FC2',
                    color: 'white',
                    border: 'none',
                    borderRadius: '20px',
                    padding: ' 10px 28px',
                  }}
                  onClick={() => {
                    handleSubmit(formData);
                  }}
                >
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: 'white',
                    color: '#007FC2',
                    border: '1px solid #007FC2',
                    borderRadius: '20px',
                    padding: ' 10px 28px',
                  }}
                  onClick={closeAcceptModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
            gap: '15px',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {poDetails?.is_accepted_item === 0 &&
              (poDetails?.is_order_accepted === 0 ||
                poDetails?.is_order_accepted === 8 ||
                poDetails?.is_order_accepted === 9) && (
                <button
                  className="submit-btn"
                  onClick={() => handleApprovalAPIApprove(remark)}
                >
                  Approve
                </button>
              )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {poDetails?.is_accepted_item === 0 &&
              (poDetails?.is_order_accepted === 0 ||
                poDetails?.is_order_accepted === 8 ||
                poDetails?.is_order_accepted === 9) && (
                <button
                  className="submit-btn"
                  onClick={() => setShowRejectModal(true)}
                >
                  Reject
                </button>
              )}
          </div>
        </div>
      </div>
      <div style={{ padding: '24px' }} className=" mt-4">
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            paddingBottom: '22px',
          }}
        >
          <h5 style={{ fontWeight: '600', fontSize: '18px' }}>Order Details</h5>
        </div>

        {/* {showRejectModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h5 style={{paddingBottom:"10px"}}>Remarks</h5>
            <textarea
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Add your remarks here"
              rows="4"
              className="remark-textarea"
            />
            <div className="modal-buttons">
              <button onClick={()=>handleApprovalAPI(remark)} className="submit-button">
                Submit
              </button>
              <button onClick={handleRejectModalClose} className="cancel-button">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )} */}

        {/* {showDateModal && (
          <div className="customModalOverlay">
            <div className="custom-modal-expectedDate">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: "18px" }}>Expected Delivery Date</h6>
                <button className="close-button" onClick={closeDateModal}>
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <label
                  htmlFor="expectedDate"
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                  }}
                >
                  Expected Delivery Date
                </label>
                <div className="input-group">
                  <DatePicker
                    ref={(ref) =>
                      (datePickerRefs.current["expectedDate"] = ref)
                    }
                    placeholderText="DD/MM/YYYY"
                    selected={
                      expectedDate
                        ? new Date(expectedDate.split("/").reverse().join("-"))
                        : null
                    }
                    onChange={(date) => handleChange("expectedDate", date)}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    popperPlacement="bottom-start"
                    minDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <span
                    className="input-group-text"
                    onClick={() => openDatePicker("expectedDate")}
                    style={{ cursor: "pointer" }}
                  >
                    <FaCalendarAlt />
                  </span>
                </div>
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{
                    background: "#007FC2",
                    color: "white",
                    border: "none",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={handleDateSubmit}
                >
                  Submit
                </button>
                <button
                  className="btn btn-primary"
                  style={{
                    background: "white",
                    color: "#007FC2",
                    border: "1px solid #007FC2",
                    borderRadius: "20px",
                    padding: " 10px 28px",
                  }}
                  onClick={closeDateModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )} */}

        {showDateModal && (
          <div className="customModalOverlay">
            <div className="custom-modal-expectedDate">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Expected Delivery Date</h6>
                <button className="close-button" onClick={closeDateModal}>
                  ×
                </button>
              </div>

              {/* CONDITIONAL CONTENT BASED ON STOCK */}
              <div className="custom-modal-body">
                <>
                  <label
                    htmlFor="expectedDate"
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                    }}
                  >
                    Expected Delivery Date
                  </label>
                  <div className="input-group">
                    <DatePicker
                      ref={(ref) =>
                        (datePickerRefs.current['expectedDate'] = ref)
                      }
                      placeholderText="DD/MM/YYYY"
                      selected={
                        expectedDate
                          ? new Date(
                              expectedDate.split('/').reverse().join('-'),
                            )
                          : null
                      }
                      onChange={(date) => handleChange('expectedDate', date)}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    <span
                      className="input-group-text"
                      onClick={() => openDatePicker('expectedDate')}
                      style={{ cursor: 'pointer' }}
                    >
                      <FaCalendarAlt />
                    </span>
                  </div>
                </>
                {/* )} */}
              </div>

              <div className="custom-modal-footer">
                {/* Hide Submit button when stock insufficient */}
                {availableQuantity !== null &&
                availableQuantity < (selectedItem?.accepted_qty || 0) ? (
                  <button
                    className="btn btn-primary"
                    style={{
                      background: 'white',
                      color: '#007FC2',
                      border: '1px solid #007FC2',
                      borderRadius: '20px',
                      padding: '10px 28px',
                    }}
                    onClick={closeDateModal}
                  >
                    Close
                  </button>
                ) : (
                  <>
                   <button
                   className="btn btn-primary"
                    style={{
                      background: expectedDate ? '#007FC2' : '#ccc',
                      color: expectedDate ? 'white' : '#666',
                      border: 'none',
                      borderRadius: '20px',
                      padding: '10px 28px',
                      cursor: expectedDate ? 'pointer' : 'not-allowed',
                    }}
                    onClick={handleDateSubmit}
                    disabled={!expectedDate}
                  >
                    Submit
                  </button>
                    {/* <button
                      className="btn btn-primary"
                      style={{
                        background: 'white',
                        color: '#007FC2',
                        border: '1px solid #007FC2',
                        borderRadius: '20px',
                        padding: '10px 28px',
                      }}
                      onClick={closeDateModal}
                    >
                      Cancel
                    </button> */}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {bulkExpectedDeliveryDate && (
          <div className="customModalOverlay">
            <div className="custom-modal-expectedDate">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Expected Delivery Date</h6>
                <button className="close-button" onClick={closeBulkDateModal}>
                  ×
                </button>
              </div>

              {/* CONDITIONAL CONTENT BASED ON STOCK */}
              <div className="custom-modal-body">
                <>
                  <label
                    htmlFor="expectedDate"
                    style={{
                      display: 'block',
                      marginBottom: '8px',
                      fontWeight: 'bold',
                    }}
                  >
                    Expected Delivery Date
                  </label>
                  <div className="input-group">
                    <DatePicker
                      // withPortal
                      ref={(ref) =>
                        (datePickerRefs.current['expectedDate'] = ref)
                      }
                      placeholderText="DD/MM/YYYY"
                      selected={
                        expectedDate
                          ? new Date(
                              expectedDate.split('/').reverse().join('-'),
                            )
                          : null
                      }
                      onChange={(date) => handleChange('expectedDate', date)}
                      dateFormat="dd/MM/yyyy"
                      className="form-control"
                      popperPlacement="bottom-start"
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    <span
                      className="input-group-text"
                      onClick={() => openDatePicker('expectedDate')}
                      style={{ cursor: 'pointer' }}
                    >
                      <FaCalendarAlt />
                    </span>
                  </div>
                </>
                {/* )} */}
              </div>

              <div className="custom-modal-footer">
                {/* Hide Submit button when stock insufficient */}
                {availableQuantity !== null &&
                availableQuantity < (selectedItem?.accepted_qty || 0) ? (
                  <button
                    className="btn btn-primary"
                    style={{
                      background: 'white',
                      color: '#007FC2',
                      border: '1px solid #007FC2',
                      borderRadius: '20px',
                      padding: '10px 28px',
                    }}
                    onClick={closeBulkDateModal}
                  >
                    Close
                  </button>
                ) : (
                  <>
                    <button
                      className="btn btn-primary"
                      style={{
                        background: !expectedDate ? 'lightgray' : '#007FC2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '20px',
                        padding: '10px 28px',
                      }}
                      disabled={!expectedDate}
                      onClick={handleBulkDateSubmit}
                    >
                      Submit
                    </button>
                    {/* <button
                      className="btn btn-primary"
                      style={{
                        background: "white",
                        color: "#007FC2",
                        border: "1px solid #007FC2",
                        borderRadius: "20px",
                        padding: "10px 28px",
                      }}
                      onClick={closeDateModal}
                    >
                      Cancel
                    </button> */}
                  </>
                )}
              </div>
            </div>
          </div>
        )}

        {batteryModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal-battery">
              <div className="custom-modal-header">
                <div className="battery-details">
                  <p>
                    <span className="battery-label">Battery Name:</span>
                    <span className="battery-value">
                      {batteryDetails.battryName}
                    </span>
                  </p>
                  <p>
                    <span className="battery-label">Battery Qty:</span>
                    <span className="battery-value">
                      {batteryDetails.total_battery_qty}
                    </span>
                  </p>
                </div>
                <button
                  className="close-button"
                  onClick={handleCloseBatteryModal}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                {/* Add the inputs here */}
                <div className="custom-modal-body">
                  <div className="battery-inputs-grid">
                    {/* {Array.from({
                      length: Number(batteryDetails.total_battery_qty) || 0,
                    }).map((_, idx) => (
                      <input
                        key={idx}
                        type="text"
                        className="form-control mb-2"
                        placeholder={`Enter value for battery ${idx + 1}`}
                      />
                    ))} */}
                    {Array.from({
                      length: Number(batteryDetails.total_battery_qty) || 0,
                    }).map((_, idx) => (
                      // <input
                      //   key={idx}
                      //   type="text"
                      //   className="form-control mb-2"
                      //   placeholder={`Enter value for battery ${idx + 1}`}
                      //   value={batteryNumbers[idx] || ""}
                      //   onChange={(e) => {
                      //     const newNumbers = [...batteryNumbers];
                      //     newNumbers[idx] = e.target.value;
                      //     setBatteryNumbers(newNumbers);
                      //   }}
                      // />
                      <div key={idx} style={{ marginBottom: 6 }}>
                        <input
                          type="text"
                          className={
                            'form-control mb-2 ' +
                            (batteryErrors[idx] ? 'is-invalid' : '')
                          }
                          placeholder={`Enter value for battery ${idx + 1}`}
                          value={batteryNumbers[idx] || ''}
                          onChange={(e) => {
                            const val = e.target.value.trim();
                            const newNumbers = [...batteryNumbers];
                            newNumbers[idx] = val;
                            setBatteryNumbers(newNumbers);

                            // validate duplicates
                            const errs = Array(newNumbers.length).fill(null);
                            newNumbers.forEach((num, i) => {
                              if (!num) return;
                              const count = newNumbers.filter(
                                (n) => n && n === num,
                              ).length;
                              if (count > 1)
                                errs[i] = 'Battery number must be unique';
                            });
                            setBatteryErrors(errs);
                          }}
                        />
                        {batteryErrors[idx] && (
                          <div
                            className="invalid-feedback"
                            style={{ display: 'block' }}
                          >
                            {batteryErrors[idx]}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="custom-modal-footer">
                {/* <button
                  onClick={() => handleAcceptBatteryNumbers()}
                  className="submit-button"
                >
                  Submit
                </button> */}
                <button
                  onClick={() => handleAcceptBatteryNumbers()}
                  className="submit-button"
                  disabled={
                    // disable if any duplicate errors OR not all inputs filled
                    batteryErrors.some(Boolean) ||
                    batteryNumbers.filter(Boolean).length <
                      Number(batteryDetails.total_battery_qty || 0)
                  }
                >
                  Submit
                </button>
                <button
                  onClick={handleCloseBatteryModal}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* rejectModalPopup      */}

        {rejectModalPopup && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Remarks</h6>
                <button
                  className="close-button"
                  onClick={handleRejectModalPopupClose}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Add your remarks here"
                  rows="4"
                  className="remark-textarea"
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  onClick={() => handleRejectAPIItem(remark)}
                  className="submit-button"
                >
                  Submit
                </button>
                <button
                  onClick={handleRejectModalPopupClose}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showRejectModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Remarks</h6>
                <button
                  className="close-button"
                  onClick={handleRejectModalClose}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <textarea
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Add your remarks here"
                  rows="4"
                  className="remark-textarea"
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  onClick={() => handleApprovalAPI(remark)}
                  className="submit-button"
                >
                  Submit
                </button>
                <button
                  onClick={handleRejectModalClose}
                  className="cancel-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <div
          style={{ borderBottom: '1px solid lightgray' }}
          className="d-flex flex-wrap p-3 mb-4 gap-5"
        >
          {/* {Object.entries(poDetails)
        .filter(([key]) => includedFields.includes(key)) 
        .map(([key, value], index) => (
        <div className="d-flex flex-column me-4 mb-3" key={index}>
            <h6 className="text-muted">
            {fieldLabels[key] || key.replace(/([A-Z])/g, ' $1')} 
            </h6>
            <span>{value ?? '--'}</span>
        </div>
        ))} */}
          {Object.entries(poDetails)
            .filter(([key]) => includedFields.includes(key)) // Filter out excluded fields
            .filter(
              ([key, value]) =>
                !(key === 'image_path' && !poDetails?.payment_trans_image),
            ) // Exclude image_path if payment_trans_image is null
            .map(([key, value], index) => {
              // Handle approval_remark condition
              if (
                key === 'approval_remark' &&
                (!value || value.trim() === '')
              ) {
                value = poDetails.remark;
              }

              // Concatenate dealer_address, city_name, and state_name for Address
              if (key === 'dealer_address') {
                value = `${poDetails.dealer_address || ''}, ${
                  poDetails.city_name || ''
                }, ${poDetails.state_name || ''}`.replace(/,\s*$/, '');
              }

              return (
                <div
                  className="col-3 col-sm-3 col-lg-3 col-xl-3 d-flex flex-column me-4 mb-3 details-section-manageorder"
                  key={index}
                >
                  <h6 className="text-muted">
                    {fieldLabels[key] || key.replace(/([A-Z])/g, ' $1')}
                  </h6>

                  {key === 'image_path' ? (
                    <img
                      src={value}
                      alt="Transaction Image"
                      onClick={() => setModalImage(value)} // Open modal with image
                      style={{
                        maxWidth: '180px',
                        height: '180px',
                        borderRadius: '5px',
                        border: '1px solid #ddd',
                        cursor: 'pointer',
                        padding: '1rem',
                        marginTop: '1rem',
                      }}
                    />
                  ) : (
                    <span className="details-value">{value ?? '--'}</span>
                  )}
                </div>
              );
            })}

          <Modal
            show={!!modalImage}
            onHide={() => setModalImage(null)}
            centered
          >
            <Modal.Body className="text-center">
              <img
                src={modalImage}
                alt="Zoomed Transaction Image"
                style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
              />
            </Modal.Body>
          </Modal>
        </div>

        {vehicleData.length > 0 && (
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <h6
                className="mt-4"
                style={{ fontWeight: '600', fontSize: '18px' }}
              >
                Vehicle Details
              </h6>

              {poStatusVal === 'Pending' && (
                <button
                  className="btn btn-outline-success"
                  onClick={handleBulkdatePopUp}
                >
                  Expected Delivery Date
                </button>
              )}
            </div>

            {renderTable(vehicleData, setVehicleData, 'Vehicle')}
          </>
        )}

        {/* <div style={{ marginTop: "40px" }}>
          <h6 style={{ fontWeight: "600", fontSize: "18px" }}>
            Battery Details
          </h6>
          <CustomTable
            data={batteryTableDetails}
            headers={TABLE_HEADERS_BATTERY}
            keyMapping={keyMappingBattery}
            itemsPerPage={10}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onEdit={handleEdit}
            totalRecords={totalRecords}
            isADDcomplainTable={true}
          />
        </div> */}

        {/* {!isBatteryClosedPersisted && batteryTableDetails.length > 0 && (
          <div style={{ marginTop: "40px" }}>
            <h6 style={{ fontWeight: "600", fontSize: "18px" }}>
              Battery Details
            </h6>
            <CustomTable
              data={batteryTableDetails}
              headers={TABLE_HEADERS_BATTERY}
              keyMapping={keyMappingBattery}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
              isADDcomplainTable={true}
            />
          </div>
        )} */}

        {/* <div style={{ marginTop: "40px" }}>
            <h6 style={{ fontWeight: "600", fontSize: "18px" }}>
              Battery Details
            </h6>
            <CustomTable
              data={batteryTableDetails}
              headers={TABLE_HEADERS_BATTERY}
              keyMapping={keyMappingBattery}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
              isADDcomplainTable={true}
            />
          </div> */}

        {accessoryData.length > 0 && (
          <>
            {/* <h6
              className="mt-4"
              style={{ fontWeight: "600", fontSize: "18px" }}
            >
              Accessories Details
            </h6> */}

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <h6
                className="mt-4"
                style={{ fontWeight: '600', fontSize: '18px' }}
              >
                Accessories Details
              </h6>

              {/* {poStatusVal === "Pending" && (
                <button
                  className="btn btn-outline-success"
                  onClick={() => {
                    handleBulkdatePopUp();
                  }}
                >
                  Expected Delivery Date
                </button>
              )} */}
            </div>

            {/* {accessoryData.map((item) => renderItemRow(item, setAccessoryData, accessoryData, 'Accessories'))} */}
            {renderTable(accessoryData, setAccessoryData, 'Accessories')}
          </>
        )}

        {sparePartData.length > 0 && (
          <>
            {/* <h6
              className="mt-4"
              style={{ fontWeight: "600", fontSize: "18px" }}
            >
              Spare Part Details
            </h6> */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <h6
                className="mt-4"
                style={{ fontWeight: '600', fontSize: '18px' }}
              >
                Battery Details
              </h6>

              {/* {poStatusVal === "Pending" ? (
                <button
                  className="btn btn-outline-success"
                  onClick={() => {
                    handleBulkdatePopUp();
                  }}
                >
                  Expected Delivery Date
                </button>
              ) : null} */}
            </div>
            {/* {sparePartData.map((item) => renderItemRow(item, setSparePartData, sparePartData, 'Spare-Parts'))} */}
            {renderTable(sparePartData, setSparePartData, 'Spare-Parts')}
          </>
        )}

        {/* Reject Modal */}

        {/* {rejectModal && (
                   <Modal show={rejectModal} onHide={handleIndividualRejectModalClose} centered>
                   <Modal.Header closeButton>
                       <h6>Remarks</h6>
                   </Modal.Header>
                   <Modal.Body>
                   <textarea
              value={rejectRemark}
              onChange={(e) => setRejectRemark(e.target.value)}
              placeholder="Add your remarks here"
              rows="4"
              className="remark-textarea"
            />
                   </Modal.Body>
                   <Modal.Footer>
                 <button className="btn btn-primary" style={{background:"red", color:"white", border:"none"}} onClick={()=> handleRejectIndividualOrder()}>
                           Reject 
                       </button>

                       <button className="btn btn-primary" onClick={handleIndividualRejectModalClose}>
                           Cancel
                       </button>
                       
                      
                   </Modal.Footer>
               </Modal>
            )} */}

        {/*   <div>
          <h6 className="mt-5" style={{ fontWeight: "600", fontSize: "18px" }}>
            Payment Details
          </h6>
          <CustomTable
            data={tablepaymentStatus}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            itemsPerPage={10}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            isADDcomplainTable={true}
          />
        </div>  */}

        {rejectModal && (
          <div className="customModalOverlay">
            <div className="custom-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Remarks</h6>
                <button
                  className="close-button"
                  onClick={handleIndividualRejectModalClose}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                <textarea
                  value={rejectRemark}
                  onChange={(e) => setRejectRemark(e.target.value)}
                  placeholder="Add your remarks here"
                  rows="4"
                  className="remark-textarea"
                />
              </div>
              <div className="custom-modal-footer">
                <button
                  className="btn btn-primary"
                  style={{ background: 'red', color: 'white', border: 'none' }}
                  onClick={handleRejectIndividualOrder}
                >
                  Reject
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleIndividualRejectModalClose}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showModal && (
          <div className="custom-modal-overlay">
            <div
              style={{ height: '60%', overflow: 'auto' }}
              className="custom-modal-itemDetails-modal"
            >
              {availableQuantity !== null &&
              availableQuantity < (selectedItem?.accepted_qty || 0) ? (
                <div>
                  <div className="custom-modal-header">
                    <h6 style={{ fontSize: '24px', fontWeight: '600' }}>
                      Update Quantity
                    </h6>
                    <button
                      className="close-button"
                      style={{ width: '24px', height: '24px' }}
                      onClick={handleModalClose}
                    >
                      <img
                        src={cancelCsv}
                        alt="cancelCsv"
                        height={24}
                        width={24}
                      />
                    </button>
                  </div>

                  <div
                    style={{
                      color: 'red',
                      fontWeight: '500',
                      fontSize: '16px',
                      paddingTop: '1rem',
                    }}
                  >
                    {showAvailableStockMessage}
                  </div>
                </div>
              ) : (
                <>
                  <div className="custom-modal-header">
                    <h6 style={{ fontSize: '24px', fontWeight: '600' }}>
                      Update Quantity
                    </h6>
                    <button
                      className="close-button"
                      style={{ width: '24px', height: '24px' }}
                      onClick={handleModalClose}
                    >
                      <img
                        src={cancelCsv}
                        alt="cancelCsv"
                        height={24}
                        width={24}
                      />
                    </button>
                  </div>

                  {/* NEW FLOW */}
                  <div className="custom-modal-body-itemDetails">
                    {/* isSpareOrAccessory */}

                    {withoutExcelSerialNumbers.length > 0 && (
                      <div
                        className="item-details-row"
                        style={{
                          display: 'flex',
                          gap: '24px',
                          marginBottom: '12px',
                          fontSize: '14px',
                          fontWeight: '500',
                          paddingTop: '1rem',
                        }}
                      >
                        {isSpareOrAccessory === 'Vehicle' ? (
                          <>
                            <span>
                              Vehicle Name :{' '}
                              <strong>
                                {withoutExcelSerialNumbers[0]?.Model || '-'}
                              </strong>
                            </span>
                            <span>
                              Variant Name :{' '}
                              <strong>
                                {withoutExcelSerialNumbers[0]?.Variant || '-'}
                              </strong>
                            </span>
                            <span>
                              Color :{' '}
                              <strong>
                                {withoutExcelSerialNumbers[0]?.Color || '-'}
                              </strong>
                            </span>
                            <span>
                              Quantity :{' '}
                              <strong>
                                {withoutExcelSerialNumbers.length}
                              </strong>
                            </span>
                          </>
                        ) : (
                          <>
                            <span>
                              Item Name :{' '}
                              <strong>
                                {withoutExcelSerialNumbers[0]?.Item || '-'}
                              </strong>
                            </span>
                            <span>
                              Quantity :{' '}
                              <strong>
                                {withoutExcelSerialNumbers.length}
                              </strong>
                            </span>
                          </>
                        )}
                      </div>
                    )}

                    {withoutExcelSerialNumbers.map((item, index) => {
                      const isSpareOrAccessory = selectedItemType;

                      console.log(
                        isSpareOrAccessory,
                        'isSpareOrAccessory>>>>>>>',
                      );

                      return (
                        <div key={index} style={{ marginBottom: '24px' }}>
                          {/* Item details row */}
                          {/* <div
                            className="item-details-row"
                            style={{
                              display: "flex",
                              gap: "24px",
                              marginBottom: "12px",
                              fontSize: "14px",
                              fontWeight: "500",
                              paddingTop: "1rem",
                            }}
                          >
                            {isSpareOrAccessory === "Vehicle" ? (
                              <>
                                <span>
                                  Vehicle Name :{" "}
                                  <strong>{item?.Model || "-"}</strong>
                                </span>
                                <span>
                                  Variant Name :{" "}
                                  <strong>{item?.Variant || "-"}</strong>
                                </span>
                                <span>
                                  Color : <strong>{item?.Color || "-"}</strong>
                                </span>
                                <span>
                                  Quantity : <strong>1</strong>
                                </span>
                              </>
                            ) : (
                              <>
                                <span>
                                  Item Name :{" "}
                                  <strong>{item?.Item || "-"}</strong>
                                </span>
                                <span>
                                  Quantity : <strong>1</strong>
                                </span>
                              </>
                            )}
                          </div> */}

                          {/* Inputs row */}
                          <div
                            className="input-row"
                            style={{
                              display: 'flex',
                              gap: '16px',
                              paddingTop: '20px',
                            }}
                          >
                            {isSpareOrAccessory === 'Vehicle' ? (
                              <>
                                {/* VIN */}
                                <div
                                  className="form-group"
                                  style={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                  }}
                                >
                                  <label
                                    style={{
                                      minWidth: '100%',
                                      marginBottom: 0,
                                    }}
                                  >
                                    VIN No.
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter VIN Number"
                                    maxLength={60}
                                    value={serialInputRows[index]?.vin_no || ''}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        'vin_no',
                                        allowAlphaNumericOnly(e.target.value),
                                      )
                                    }
                                  />
                                </div>

                                {/* Controller */}
                                <div
                                  className="form-group"
                                  style={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                  }}
                                >
                                  <label
                                    style={{
                                      minWidth: '100%',
                                      marginBottom: 0,
                                    }}
                                  >
                                    Controller No.
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Controller Number"
                                    maxLength={60}
                                    value={
                                      serialInputRows[index]?.controller_no ||
                                      ''
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        'controller_no',
                                        allowAlphaNumericOnly(e.target.value),
                                      )
                                    }
                                  />
                                </div>

                                {/* Motor */}
                                <div
                                  className="form-group"
                                  style={{
                                    flex: 1,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                  }}
                                >
                                  <label
                                    style={{
                                      minWidth: '100%',
                                      marginBottom: 0,
                                    }}
                                  >
                                    Motor No.
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Motor Number"
                                    maxLength={60}
                                    value={
                                      serialInputRows[index]?.motor_no || ''
                                    }
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        'motor_no',
                                        allowAlphaNumericOnly(e.target.value),
                                      )
                                    }
                                  />
                                </div>
                              </>
                            ) : (
                              /* SERIAL NO */
                              <div
                                className="form-group"
                                // style={{
                                //   flex: 1,
                                //   display: "flex",
                                //   alignItems: "center",
                                //   gap: "12px",
                                // }}
                                style={{ display: 'flex', gap: '16px' }}
                              >
                                <label
                                  style={{
                                    minWidth: '120px',
                                    marginBottom: 0,
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  Serial No.
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Serial Number"
                                  maxLength={60}
                                  style={{ flex: 1 }}
                                  value={
                                    serialInputRows[index]?.serial_no || ''
                                  }
                                  onChange={(e) =>
                                    handleInputChange(
                                      index,
                                      'serial_no',
                                      allowAlphaNumericOnly(e.target.value),
                                    )
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="custom-modal-footer">
                    <button
                      className="submit-btn"
                      // onClick={() => handleFormSubmit(formData)}
                      // onClick={() => fetchPoDetailWithoutExcel()}
                      onClick={handleSubmitWithoutExcel}
                      // disabled={isButtonDisabled}
                    >
                      Submit
                    </button>
                  </div>
                  {successVal > 0 || errorVal > 0 ? (
                    <div style={{ fontSize: '14px', textAlign: 'center' }}>
                      File uploaded successfully with {successVal} successful
                      rows and {errorVal} failed rows
                    </div>
                  ) : null}

                  {errorVal > 0 && (
                    <div className="result-wrapper">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          justifyContent: 'center',
                          paddingTop: '10px',
                        }}
                      >
                        <span style={{ color: 'red' }}>
                          Failed Records: {errorVal}
                        </span>
                        <img
                          src={downloadIcon}
                          alt="download"
                          className="downloadImg"
                          onClick={() => {
                            downloadFailedRowsCSV(
                              formData.uploadDocument,
                              failedRows,
                            );
                            window.location.reload(); // Refresh the page after the download
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {showSerialModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal-itemDetails-modal">
              <div className="custom-modal-header">
                <h6 style={{ fontSize: '18px' }}>Serial Details</h6>
                <button
                  className="close-button"
                  onClick={() => setShowSerialModal(false)}
                >
                  ×
                </button>
              </div>
              <div className="custom-modal-body">
                {loadingSerialData ? (
                  <div className="text-center">Loading...</div>
                ) : serialData.length > 0 ? (
                  <AcceptedSerialList
                    selectedItemType={selectedItemType}
                    podetaildID={podetailsid}
                    poStatusVal={poStatusVal}
                  />
                ) : (
                  <p className="text-center">No serial details available</p>
                )}
              </div>
            </div>
          </div>
        )}

        {/* {showSerialModal && (
    <Modal show={showSerialModal} onHide={() => setShowSerialModal(false)} centered>
        <Modal.Header closeButton>
            <div>
            <h6>Serial Details</h6>
            </div>
        </Modal.Header>
        <Modal.Body>
            {loadingSerialData ? (
                <div className="text-center">Loading...</div>
            ) : serialData.length > 0 ? (
               <AcceptedSerialList selectedItemType={selectedItemType} podetaildID={podetailsid} />
            ) : (
                <p className="text-center">No serial details available</p>
            )}
        </Modal.Body>
    </Modal>
)} */}
      </div>
    </div>
  );
};

export default AcceptOrderDetails;
